module.exports = __webpack_public_path__ + "img/atendimento.bbd763bb.jpg";